import { useTranslation } from 'react-i18next';
import { OctoLoader } from './OctoLoader';
import { loaderMessages, type LoaderKind } from './loaderMessages';
import { cn } from '@/shared/lib/cn';

/**
 * Ekran/panel beklemesi: ortalanmış dönen logo + bağlama göre ilerleyen mesaj.
 *
 * `OctoLoader`'ı doğrudan çağırmak yerine bunun olmasının sebebi, her çağrı yerinin
 * aynı ortalama sarmalayıcısını ve `useTranslation`'ı tekrar yazmak zorunda kalması;
 * ayrıca `router.tsx` gibi kanca kullanamayan yerlerde tek eleman olarak geçiyor.
 *
 * Düğme içi ya da alan yanındaki küçük beklemeler için değil — orada `Spinner` kalır.
 */
export interface ScreenLoaderProps {
  kind?: LoaderKind;
  /** Üstünü ört (kapsayıcı `relative` olmalı). `'opaque'` altını tamamen gizler. */
  overlay?: boolean | 'opaque';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ScreenLoader({ kind = 'screen', overlay, size, className }: ScreenLoaderProps) {
  const { t } = useTranslation();
  const messages = loaderMessages(t, kind);

  if (overlay) return <OctoLoader overlay={overlay} messages={messages} size={size} className={className} />;

  return (
    <div className={cn('flex flex-1 items-center justify-center p-8', className)}>
      <OctoLoader messages={messages} size={size} />
    </div>
  );
}
